<template>
  <div class="issues-total-summary-container">
    <Section>
      <div class="section-header" slot="header">
        <h1 class="title">Issue Summary</h1>
      </div>
      <div class="section-body">
        <div class="row">
          <div class="col-md-12 text-danger" v-if="error">
            * {{ error }}
          </div>
          <div class="issues-total-summary__card col-md-4">
            <IssuesSummaryCard :cardStyle="cardStyle" :onClick="() => {}">
              <i class="fa fa-layer-group fade-icon" />
              <h1 class="header-plays">
                {{ issuesData.errorPercentage.toFixed(2) }}%
              </h1>
              <div class="subheader">ISSUES FOUND</div>
              <div class="plays-subheader">
                From {{ abbreviateLongNumbers(issuesData.totalPlay) }} Plays Total
              </div>
              <div class="subheader"></div>
            </IssuesSummaryCard>
          </div>
          <div class="issues-total-summary__chart col-md-8" v-if="state.showChart">
            <IssuesBarChart :series="series" :colors="colors" />
          </div>
        </div>
      </div>
    </Section>
  </div>
</template>

<script>
import _ from 'lodash';

import numberUtils from '@/utils/numberUtils';
import IssuesBarChart from '@/charts/IssuesBarChart.vue';
import Section from '@/components/Section.vue';
import IssuesSummaryCard from '@/issues/IssuesSummaryCard.vue';

export default {
  mixins: [numberUtils],
  props: ['issuesData', 'error'],
  components: {
    Section,
    IssuesSummaryCard,
    IssuesBarChart,
  },
  data() {
    return {
      preloaderCustomClass: 'two-columns',
      state: {
        isLoading: false,
        showChart: false,
        isPreLoaderShowing: true,
      },
      series: [],
      colors: [
        '#E76F51',
        '#E8B948',
        '#2A9D8F',
        '#343967',
        '#9C9C9C',
      ],
    };
  },
  computed: {
    cardStyle() {
      return {
        borderLeft: '12px solid #5613B5',
      };
    },
  },
  created() {
    this.mapChartSeries();
    this.state.showChart = true;
    this.state.isPreLoaderShowing = false;
  },
  methods: {
    mapChartSeries() {
      this.series = _.map(this.issuesData.errorCategories, (category, index) => {
        const categoryName = category.name;
        const categoryIssuePercentage = category.errorPercentage;
        const categoryIssueCount = category.errorCount;
        return {
          name: categoryName,
          data: [categoryIssuePercentage],
          rawData: categoryIssueCount,
          colorIndex: index,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.header-plays {
  color: #5613B5
}

.subheader {
  font-size: 16px;
  color: $gray-600;
}

.issues-total-summary__card {
  margin: auto;
}

.plays-subheader {
  color: $gray-500;
  font-size: small;
  font-weight: normal;
}

.fade-icon {
  position: absolute;
  height: 45px;
  width: 45px;
  font-size: 45px;
  right: $spacer * 1.5;
  opacity: .5;
}
</style>
